import { Controller } from "@hotwired/stimulus"
import { Jodit } from "jodit"
import "jodit/esm/plugins/all.js"
import axios from "axios"
import { showLexicalAiModal } from "../noe/src/lexical_ai_modal"
// import hotkeys from "hotkeys-js" - nie działa razem z jodit poprawnie

export default class extends Controller {
  static targets = ["editor", "input", "loaded", "templateSelect", "subjectInput", "bodyTextInput", "preheaderInput"]
  static values = { loaded: Boolean }

  editor = null

  connect() {
    if (this.loadedValue) {
      // musimy stworzyć edytor od nowa, bo inaczej nie będziemy mieli ustawionej wartości w this.editor
      const oldEditor = document.getElementsByClassName("jodit-container")[0]
      if (oldEditor) {
        oldEditor.remove()
      }
    }

    console.log("connect jodit")
    if (this.hasEditorTarget) {
      this.editor = this.createEditor()

      // autofocus - fokus na edytor po utworzeniu
      if (this.editorTarget.dataset.autofocus === "1") {
        setTimeout(() => {
          // dla ACE editor fokus na ukryty input
          const aceInput = this.element.querySelector(".ace_text-input")
          if (aceInput) {
            aceInput.focus()
          } else {
            this.editor.focus()
          }
        }, 100)
      }

      // wklej czysty tekst
      this.editor.events.on("keydown", (e) => {
        if ((e.ctrlKey || (e.metaKey && e.altKey)) && e.shiftKey && e.key.toLowerCase() === "v") {
          e.preventDefault()

          // Read plain text from clipboard
          navigator.clipboard.readText().then(text => {
            this.editor.selection.insertHTML(text.replace(/\n/g, "<br>"))
          }).catch(err => {
            console.error("Clipboard read error:", err)
          })
        }
      })
    }

    this.updateFooter() // w edycji bez tego nie pokazywał się footer
    this.loadedValue = true
    console.log(this.editor)
  }

  createEditor() {
    // Jodit.MODE_WYSIWYG = 1, Jodit.MODE_SOURCE = 2
    const sourceMode = this.editorTarget.dataset.sourceMode === "1"
    // iframe izoluje edytowaną treść w osobnym dokumencie - style z <style> w szablonie
    // nie wyciekają wtedy na całą aplikację (używane m.in. w szablonach dokumentów)
    const useIframe = this.editorTarget.dataset.joditIframe === "1"

    // Konfiguracja przycisku AI (opcjonalna) — renderowana jako ikona w toolbarze Jodit
    const aiConfig = this.element.querySelector("[data-jodit-ai-config]")
    const aiControl = aiConfig ? this._aiControl(aiConfig) : null

    const buttons = [
      "source", "|",
      "bold",
      "strikethrough",
      "underline",
      "italic", "|",
      "ul",
      "ol", "|",
      "outdent", "indent", "|",
      "font",
      "fontsize",
      "brush",
      "paragraph", "|",
      "image",
      "table",
      "link", "|",
      "align", "undo", "redo", "|",
      "hr",
      "eraser",
      "preview"
    ]
    if (aiControl) {
      buttons.unshift("ai", "|")
    }

    return new Jodit(`#${this.editorTarget.id}`, {
      iframe: useIframe,
      link: {
        processVideoLink: false
      },
      style: { font: "14px Arial" },
      tabIndex: 0,
      autofocus: this.editorTarget.autofocus,
      cursorAfterAutofocus: "start",
      spellcheck: true, // Włącza sprawdzanie pisowni
      toolbarAdaptive: false,
      toolbarSticky: false,
      minHeight: "200px",
      defaultMode: sourceMode ? Jodit.MODE_SOURCE : Jodit.MODE_WYSIWYG,
      // sourceEditor: "area",
      colorPickerDefaultTab: "text",
      buttons,
      controls: {
        ...(aiControl ? { ai: aiControl } : {}),
        paragraph: {
          list: Jodit.atom({
            p: "Pharagraph",
            h2: "Heading 1",
            h3: "Heading 2",
            h4: "Heading 3",
            h5: "Heading 4",
            blockquote: "Quote",
            pre: "Source code"
          })
        }
      },
      enter: "br",
      commandToHotkeys: {
        // https://mdn.github.io/dom-examples/execcommand/
        // zakomentowane opcje są domyślnie w jodit
        // undo: ["ctrl+z", "meta+z"],
        // redo: ["ctrl+shift+z", "meta+shift+z"],
        // bold: ["ctrl+b", "meta+b"],
        // italic: ["ctrl+i", "meta+i"],
        // underline: ["ctrl+u", "meta+u"],
        // createlink: ["ctrl+k", "meta+k"],
        // unlink: ["ctrl+shift+k", "meta+shift+k"], - nie działa w całości
        // insertorderedlist: ["ctrl+shift+7", "meta+shift+7"], - nie działa
        // insertunorderedlist: ["ctrl+shift+8", "meta+shift+8"], - nie działa
        // outdent: ["ctrl+[", "meta+["], - nie działa z powodu enter: "br"
        // indent: ["ctrl+]", "meta+]"], - nie działa z powodu enter: "br"
        // insertimage: ["ctrl+shift+i", "meta+shift+i"], - nie działa
        strikethrough: ["ctrl+shift+s", "meta+shift+s"],
        justifycenter: ["ctrl+e", "meta+e"],
        justifyfull: ["ctrl+j", "meta+j"],
        justifyleft: ["ctrl+l", "meta+l"],
        justifyright: ["ctrl+r", "meta+r"],
        inserthorizontalrule: ["ctrl+shift+-", "meta+shift+-"],
      },
      tabInsideLiInsertNewList: true,
      showCharsCounter: false,
      showWordsCounter: false,
      showXPathInStatusbar: false,
      showPlaceholder: false,
      askBeforePasteHTML: false,
      language: this.editorTarget.dataset.locale || "en",
      uploader: {
        url: this.editorTarget.getAttribute("data-direct-upload-url"),
        // insertImageAsBase64URI: true,
        imagesExtensions: ["jpg", "png", "jpeg", "gif", "svg", "webp"],
        format: "json",
        headers: {
          "X-CSRF-Token": document
            .querySelector("meta[name=\"csrf-token\"]")
            .getAttribute("content")
        },
        data: {
          in_text: "true",
          public: this.editorTarget.dataset.publicUpload || "false"
        },
        isSuccess: function (resp) {
          return !resp.error
        },
        getMessage: function (resp) {
          return resp.msg
        },
        process: function (resp) {
          return {
            attachments: resp.attachments || [],
            errors: resp.errors || [],
          }
        },
        defaultHandlerSuccess: function (data, _resp) {
          let i
          const field = "attachments"
          if (data[field] && data[field].length) {
            for (i = 0; i < data[field].length; i += 1) {
              console.log(data[field][i])
              const img = this.createInside.fromHTML(`<img src="${data[field][i].url}" src-old="${data[field][i].cid}">`)
              this.s.insertNode(img)
            }
          }

          if (data.errors && data.errors.length > 0) {
            this.message.message(data.errors.map(e => e.error + " " + e.attachment).join(", "), "error", 5000)
          }
        },
      },
      events: {
        beforePaste: function(event) {
          const items = (event.clipboardData || event.originalEvent.clipboardData).files
          const hasImage = items.length > 0
          const editorTarget = document.querySelector("[data-jodit-target='editor']")

          if (hasImage && (!editorTarget.hasAttribute("data-images") || editorTarget.dataset.images !== "1")) {
            this.fire("errorMessage", "Sorry, You can't paste image here")
            return false
          }

          return true
        }
      }
    })
  }

  insertTemplate(event) {
    const csrfToken = document.querySelector("[name=\"csrf-token\"]").content
    const templateId = event.currentTarget.value
    console.log("templateId", templateId)
    if (!templateId) { return }

    const mailboxSelect = document.querySelector("[data-id='mailbox_id']")
    const mailboxId = mailboxSelect ? mailboxSelect.value : ""
    const url = event.currentTarget.dataset.url + "?template_id=" + templateId + "&mailbox_id=" + mailboxId
    fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": csrfToken
      },
    })
      .then(response => response.json())
      .then(data => this.insertTemplateData(data))
      .catch((error) => {
        console.error("Error:", error)
      })
  }

  insertTemplateData(data) {
    this.subjectInputTarget.value = data.subject
    // Pola dodatkowe: podstawiamy tylko gdy szablon je ma - nie kasujemy ręcznie wpisanych wartości pustym szablonem
    if (this.hasBodyTextInputTarget && data.body_text) { this.bodyTextInputTarget.value = data.body_text }
    if (this.hasPreheaderInputTarget && data.preheader) { this.preheaderInputTarget.value = data.preheader }
    const content = data.content
    // const editorDiv = this.editor.currentPlace.editor
    // debugger
    // usuwanie poprzedniego szablonu, znajdujemy pierwszy szablon z brzegu i sprawdzamy czy nic go nie poprzedza,
    // bo jesli tak to znaczy ze jest on juz wewnatrz tresci i nie chcemy go wywalac
    // const firstTemplate = document.querySelector('.intum_template')
    // console.log(firstTemplate, 'firstTemplate')
    // if (firstTemplate && firstTemplate.parentNode.firstChild === firstTemplate) { firstTemplate.remove() }

    const contentDiv = this.editor.createInside.element("div")
    contentDiv.classList.add("intum_template")
    contentDiv.innerHTML = content

    // to wywolanie umieszcza tresc szablonu na poczatku edytora
    this.editor.setEditorValue("")
    this.editor.s.insertNode(contentDiv)
    this.updateFooter()
  }

  updateEditor(event) {
    event.preventDefault()
    this.updateFooter()
  }

  updateFooter() {
    document.activeElement.blur()
    if (!this.hasInputTarget) { return }

    let input = ""

    if (this.inputTarget.tagName === "SELECT" && this.inputTarget.selectedOptions.length > 0) {
      input = this.inputTarget.selectedOptions[0].value
    } else {
      input = this.inputTarget.value
    }

    const id = this.inputTarget.dataset.id
    const url = this.inputTarget.dataset.url
    const intumReply = document.querySelector(".jodit-wysiwyg > .intum_reply")

    axios.get(url, {
      params: {
        [id]: input
      },
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest"
      }
    })
      .then(response => {
        console.log(response.data)
        let footer = document.querySelector(".jodit-wysiwyg > .intum_footer")

        if (footer) {
          if (response.data) {
            footer.outerHTML = response.data
          } else {
            footer.remove()
          }
        } else if (response.data) {
          footer = document.createElement("div")
          if (intumReply) {
            intumReply.parentNode.insertBefore(footer, intumReply)
          } else {
            const wysiwyg = document.querySelector(".jodit-wysiwyg")
            wysiwyg.appendChild(footer)
          }
          footer.outerHTML = response.data
        }

        this.setFocus()
      })
      .catch(error => {
        console.log("error updating")
        console.warn(error)
      })
  }

  setFocus() {
    const content = document.querySelector(".jodit-wysiwyg")
    if (content && content.firstChild) {
      this.editor.selection.setCursorBefore(content.firstChild)
    }
  }

  // czyszczenie edytora z lekkim opóźnieniem
  // (by formularz zdążył się najpierw wysłać w przypadku użycia funkcji po wysłaniu formularza)
  clearEditor() {
    if (this.editor) {
      setTimeout(() => {
        this.editor.value = ""
      }, 200)
    }
  }

  disconnect() {
    this._aiModal?.remove()
    if (this.editor) {
      try {
        this.editor.remove()
      } catch (_e) {
        // Jodit może rzucić błąd gdy DOM jest już zniszczony (np. Turbo back)
      }
    }
  }

  // --- AI ---
  // Rejestruje ikonę "ai" w zestawie ikon Jodit (idempotentne, wywoływane przy tworzeniu edytora).
  _registerAiIcon() {
    const svg = "<svg viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.5\"><path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M9.813 15.904 9 18.75l-.813-2.846a4.5 4.5 0 0 0-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 0 0 3.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 0 0 3.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 0 0-3.09 3.09ZM18.259 8.715 18 9.75l-.259-1.035a3.375 3.375 0 0 0-2.455-2.456L14.25 6l1.036-.259a3.375 3.375 0 0 0 2.455-2.456L18 2.25l.259 1.035a3.375 3.375 0 0 0 2.455 2.456L21.75 6l-1.036.259a3.375 3.375 0 0 0-2.455 2.456ZM16.894 20.567 16.5 21.75l-.394-1.183a2.25 2.25 0 0 0-1.423-1.423L13.5 18.75l1.183-.394a2.25 2.25 0 0 0 1.423-1.423l.394-1.183.394 1.183a2.25 2.25 0 0 0 1.423 1.423l1.183.394-1.183.394a2.25 2.25 0 0 0-1.423 1.423Z\" /></svg>"
    Jodit.modules?.Icon?.set?.("ai", svg)
  }

  // Definicja przycisku "ai" w toolbarze Jodit — ikona + popup z 3 trybami.
  _aiControl(aiConfig) {
    this._registerAiIcon()
    return {
      name: "ai",
      icon: "ai",
      tooltip: aiConfig.dataset.aiTooltip || "AI",
      popup: (_editor, _current, close) => this._buildAiPopup(aiConfig, close),
    }
  }

  // Buduje zawartość popupu przycisku AI (3 opcje: spelling/polish/creative).
  _buildAiPopup(aiConfig, close) {
    const d = aiConfig.dataset
    const options = [
      { mode: "spelling", prompt: "mail_spelling_editor", title: d.aiSpellingTitle, desc: d.aiSpellingDesc },
      { mode: "polish", prompt: "mail_polish_editor", title: d.aiPolishTitle, desc: d.aiPolishDesc },
      { mode: "creative", prompt: d.aiContext, title: d.aiCreativeTitle, desc: d.aiCreativeDesc },
    ]

    const menu = document.createElement("div")
    menu.className = "py-1 w-64 bg-white"
    options.forEach((opt) => {
      const btn = document.createElement("button")
      btn.type = "button"
      btn.className = "w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 block"
      btn.innerHTML = `<div class="font-medium">${opt.title || ""}</div><div class="text-xs text-gray-500 mt-0.5">${opt.desc || ""}</div>`
      btn.addEventListener("click", () => {
        close && close()
        if (opt.mode === "creative") {
          this._openAiModal(aiConfig, opt.prompt)
        } else {
          this._applyAiDirectly(aiConfig, opt.prompt)
        }
      })
      menu.appendChild(btn)
    })
    return menu
  }

  // Otwiera modal kreatywnego AI i wstawia wygenerowaną treść do edytora.
  _openAiModal(aiConfig, promptCode) {
    this._aiModal?.remove()
    this._aiModal = showLexicalAiModal({
      aiContext: promptCode,
      aiMode: "creative",
      promptLabel: aiConfig.dataset.aiPromptLabel || undefined,
      onUseResponse: (content) => {
        this.editor.value = content
      },
      onClose: () => {
        this._aiModal = null
        this.editor?.focus()
      },
    })
  }

  // Wysyła aktualną treść edytora do AI i nadpisuje ją poprawioną wersją (spelling/polish).
  async _applyAiDirectly(aiConfig, promptCode) {
    const t = (key, fallback) => (aiConfig?.dataset?.[key]) || fallback

    const currentContent = this.editor ? this.editor.value : ""
    if (!currentContent.trim()) {
      alert(t("aiEmpty", "Editor is empty"))
      return
    }

    const csrfToken = document.querySelector("meta[name='csrf-token']").content

    // spinner overlay nad kontenerem edytora Jodit
    const container = this.editor?.container || this.element
    if (getComputedStyle(container).position === "static") {
      container.style.position = "relative"
    }
    const overlay = document.createElement("div")
    overlay.className = "absolute inset-0 bg-white/80 flex items-center justify-center rounded-md z-10"
    overlay.innerHTML = `
      <div class="flex flex-col items-center gap-3">
        <div class="w-10 h-10 rounded-full animate-spin border-4 border-solid border-blue-500 border-t-transparent"></div>
        <div class="text-sm text-gray-600 font-medium">${t("aiLoading", "AI...")}</div>
      </div>
    `
    container.appendChild(overlay)

    try {
      // utworzenie konwersacji z wybranym system promptem
      const createRes = await fetch("/noe/conversations/create_for_ai.json", {
        method: "POST",
        headers: { "X-CSRF-Token": csrfToken, "Content-Type": "application/json", Accept: "application/json" },
        credentials: "same-origin",
        body: JSON.stringify({ ai_context: promptCode }),
      })
      const createData = await createRes.json()
      if (!createRes.ok) {
        alert(createData.error || t("aiErrorCreate", "Error"))
        return
      }

      // wysłanie treści edytora jako wiadomości
      const sendRes = await fetch(createData.send_message_url, {
        method: "POST",
        headers: { "X-CSRF-Token": csrfToken, "Content-Type": "application/json", Accept: "application/json" },
        credentials: "same-origin",
        body: JSON.stringify({ content: currentContent }),
      })
      const sendData = await sendRes.json()
      if (!sendRes.ok) {
        alert(sendData.error || t("aiErrorGenerate", "Error"))
        return
      }

      // nadpisanie treści edytora odpowiedzią AI
      this.editor.value = sendData.assistant_message.content
    } catch (error) {
      console.error("AI error:", error)
      alert(t("aiErrorConnection", "Connection error"))
    } finally {
      overlay.remove()
      this.editor?.focus()
    }
  }
}
